// Runtime webpack config
import '../../other/WebpackConfig';

import '../../../scss/vip.mp.nlnl.scss';

// i18n
import i18n from '../../i18n/nl-NL';

import vip from './vip';

vip(i18n);
